/**
 * NotificationStreamProvider
 *
 * Initializes the SSE notification stream connection at the app level.
 * Only activates when the user is authenticated and has a workspace selected.
 * Should be mounted inside the Router context.
 */

import React from 'react';
import { useNotificationStream } from '../hooks/useNotificationStream';
import { useIsAuthenticated, useCurrentWorkspaceId } from '../hooks/useStoreSelectors';

export const NotificationStreamProvider: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const workspaceId = useCurrentWorkspaceId();

  // Only connect when authenticated and workspace is selected
  if (isAuthenticated && workspaceId) {
    return <NotificationStreamConnector />;
  }

  return null;
};

/**
 * Inner component that actually connects to the stream.
 * Separated to ensure hooks are called unconditionally.
 */
const NotificationStreamConnector: React.FC = () => {
  useNotificationStream({
    showToasts: true,
  });

  return null;
};

NotificationStreamProvider.displayName = 'NotificationStreamProvider';